import { ageBinsReverse } from "Lookups";
import config from "Config";

const substituteForCommunityAggregation = (query) =>
  query
    .replace(/\{\{geo_aggregation\}\}/g, "{{community_aggregation}}")
    .replace(
      /\{\{geo_aggregation_value_column\}\}/g,
      "{{community_aggregation_value_column}}"
    )
    .replace(
      /\{\{optionally_reduce_geo_aggregation_value\}\}/g,
      "{{optionally_reduce_community_aggregation_value}}"
    );

const naQueryTemplate = (
  query_name,
  table_suffix,
  column_name,
  na_value = "Not applicable"
) => `/* ${query_name} */
  SELECT COALESCE(SUM(number), 0) AS number
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_${table_suffix}
  {{optionally_reduce_geo_aggregation_value}}
  AND ${column_name} = '${na_value}'`;

export const MAP_QUERY =
  "/* MAP_QUERY */ SELECT {{community_column}} as community_name, {{interactivity}}, bounds.the_geom_webmercator \
          FROM {{community_table}} as community, {{boundary_table}} as bounds \
          WHERE {{community_column}} = $${{community_value}}$$ {{join_statement}}";

export const MAP_QUERY_NO_COMMUNITY_VALUE = `/* MAP_QUERY_NO_COMMUNITY_VALUE */ SELECT bounds.the_geom_webmercator, sum(number) as number, {{geo_aggregation_column}} \
   FROM ${config.cartodb_username}_{{year}}_{{map_geo_aggregation}}_demo_age5gend as community, {{boundary_table}} as bounds \
   WHERE 1 = 1 {{join_statement}} GROUP BY {{geo_aggregation_column}}, bounds.the_geom_webmercator`;

export const BOUNDARY_QUERY = `/* BOUNDARY_QUERY */
  SELECT
   ROUND(ST_XMin(ST_Extent(the_geom))) AS minx,
   ROUND(ST_YMin(ST_Extent(the_geom))) AS miny,
   ROUND(ST_XMax(ST_Extent(the_geom))) AS maxx,
   ROUND(ST_YMax(ST_Extent(the_geom))) AS maxy
  FROM (
    SELECT the_geom FROM {{boundary_table}}
    WHERE {{geo_aggregation_column}} = $\${{geo_aggregation_value}}$$
  ) as subq`;

export const POLYGON_QUERY = `SELECT the_geom_webmercator
  FROM {{boundary_table}}
  {{optionally_reduce_geo_aggregation_value}}`;

export const COMMUNITY_QUERY =
  "/* COMMUNITY_QUERY */ SELECT SUM(number) as number FROM {{community_table}} \
   WHERE {{community_column}} = $${{community_value}}$$";

export const COMMUNITY_QUERY_DIVISION = `/* COMMUNITY_QUERY_DIVISION */
  SELECT COALESCE( SUM(number), 0 ) as number FROM {{community_table}}
      {{optionally_reduce_geo_aggregation_value}}
      AND {{community_column}} = $\${{community_value}}$$`;

export const TOTAL_POPULATION = ` /* TOTAL_POPULATION */
  SELECT COALESCE(SUM(number), 0) as number
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_demo_age5gend
  {{optionally_reduce_geo_aggregation_value}}`;

export const TOTAL_POPULATION_STATE = `/* TOTAL_POPULATION_STATE */
  SELECT sum(number) as number
  FROM ${config.cartodb_username}_{{year}}_ste_demo_age5gend`;

// Summary related Queries see: https://github.com/geografia-au/dlgcwa/issues/54

export const BIRTHPLACE_NOT_STATED = `/* BIRTHPLACE_NOT_STATED */
  SELECT sum(number) AS number
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_cult_birthpl
  {{optionally_reduce_geo_aggregation_value}}
  AND (bplp_country_of_birth_of_person = 'Not stated'
  OR bplp_country_of_birth_of_person = 'Inadequately described')`;

export const BIRTHPLACE_NOT_STATED_STATE_WIDE = `/* BIRTHPLACE_NOT_STATED_STATE_WIDE */
  SELECT sum(number) AS number
  FROM ${config.cartodb_username}_{{year}}_ste_cult_birthpl
  WHERE bplp_country_of_birth_of_person = 'Not stated'
  OR bplp_country_of_birth_of_person = 'Inadequately described'`;

// queries for detailed categories (see check marks https://github.com/geografia-au/dlgcwa/issues/10)
export const CATEGORY_AGE_AND_GENDER = `/* CATEGORY_AGE_AND_GENDER */
  SELECT sexp_sex, sum(number) AS number, age5p_age_in_five_year_groups
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_demo_age5gend
  {{optionally_reduce_geo_aggregation_value}}
  GROUP BY sexp_sex, age5p_age_in_five_year_groups
  ORDER BY ${ageBinsReverse}`;

export const CATEGORY_AGE_AND_GENDER_TOTAL = `/* CATEGORY_AGE_AND_GENDER_TOTAL */
  SELECT sexp_sex, sum(number) AS number
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_demo_age5gend
  {{optionally_reduce_geo_aggregation_value}}
  GROUP BY sexp_sex`;

export const CATEGORY_AGE_AND_GENDER_NA = `/* CATEGORY_AGE_AND_GENDER_NA */ SELECT 0 AS number`;
export const CATEGORY_AGE_AND_GENDER_COMMUNITY_NA = `/* CATEGORY_AGE_AND_GENDER_COMMUNITY_NA */ SELECT 0 AS number`;


export const CATEGORY_SERVICE_AGE = `/* CATEGORY_SERVICE_AGE */
  SELECT service_age, sum(number) as number, sexp_sex
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_demo_age5gend
  {{optionally_reduce_geo_aggregation_value}}
  GROUP BY service_age, sexp_sex
  ORDER BY
  service_age = '85+ years',
  service_age = '65-84 years',
  service_age = '55-64 years',
  service_age = '35-54 years',
  service_age = '25-34 years',
  service_age = '15-24 years',
  service_age = '0-14 years', sexp_sex`;

export const CATEGORY_SERVICE_AGE_NA = `/* CATEGORY_SERVICE_AGE_NA */ SELECT 0 AS number`;

export const CATEGORY_AGE_15_PLUS_TOTAL = `/*CATEGORY_AGE_15_PLUS_TOTAL*/ 
  select sum(number) as number from ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_demo_age5gend
  {{optionally_reduce_geo_aggregation_value}} 
  AND age5p_age_in_five_year_groups NOT IN ('0-4 years','5-9 years','10-14 years')`;

export const CATEGORY_AGE_15_PLUS_TOTAL_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_AGE_15_PLUS_TOTAL
);

export const CATEGORY_AGE_15_PLUS_STATE_TOTAL = `/*CATEGORY_AGE_15_PLUS_STATE_TOTAL*/
  SELECT SUM(number) AS number
  FROM ${config.cartodb_username}_{{year}}_ste_demo_age5gend
  WHERE 1=1
  AND age5p_age_in_five_year_groups NOT IN ('0-4 years','5-9 years','10-14 years')`;
  
export const CATEGORY_BIRTHPLACE_NA = naQueryTemplate(
  "CATEGORY_BIRTHPLACE_NA",
  "cult_birthpl",
  "bplp_country_of_birth_of_person"
);

export const CATEGORY_BIRTHPLACE_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_BIRTHPLACE_NA
);

export const CATEGORY_BIRTHPLACE = `/* CATEGORY_BIRTHPLACE */
  SELECT cartodb_id as id, born_in_australia,
    main_english_speaking, bplp_country_of_birth_of_person, number
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_cult_birthpl
    {{optionally_reduce_geo_aggregation_value}}
    AND bplp_country_of_birth_of_person != 'Not stated'
    AND bplp_country_of_birth_of_person != 'Inadequately described'
    AND born_in_australia = false
    AND number != 0
  ORDER BY number DESC LIMIT 20`;

export const CATEGORY_BIRTHPLACE_TOP = `/* CATEGORY_BIRTHPLACE_TOP */
  SELECT cartodb_id as id, born_in_australia,
    bplp_country_of_birth_of_person, number
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_cult_birthpl
    {{optionally_reduce_geo_aggregation_value}}
    AND bplp_country_of_birth_of_person != 'Inadequately described'
    AND born_in_australia = false
    AND bplp_country_of_birth_of_person != 'Not stated'
  ORDER BY number DESC LIMIT 1`;

export const CATEGORY_LGA_DISTRIBUTION = `/* CATEGORY_LGA_DISTRIBUTION */
  SELECT cartodb_id as id,
    local_government_areas_{{year}}_boundaries_ur,
    dlgc_cat,
    number
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_intro_lga
  {{optionally_reduce_geo_aggregation_value}}
  AND number != 0
  ORDER BY number DESC LIMIT 20`;

export const CATEGORY_BORN_IN_AU = `/* CATEGORY_BORN_IN_AU */
  SELECT born_in_australia, sum(number) AS number
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_cult_birthpl
    {{optionally_reduce_geo_aggregation_value}}
    AND bplp_country_of_birth_of_person != 'Not stated'
    AND bplp_country_of_birth_of_person != 'Inadequately described'
    AND born_in_australia IS NOT NULL
  GROUP BY born_in_australia`;

export const CATEGORY_BORN_IN_AU_NA = naQueryTemplate(
  "CATEGORY_BORN_IN_AU_NA",
  "cult_birthpl",
  "bplp_country_of_birth_of_person"
);

export const CATEGORY_BORN_IN_AU_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_BORN_IN_AU_NA
);

export const CATEGORY_BORN_IN_AU_STATE_WIDE = `/* CATEGORY_BORN_IN_AU_STATE_WIDE */
  SELECT born_in_australia, sum(number) AS number
  FROM ${config.cartodb_username}_{{year}}_ste_cult_birthpl
  WHERE bplp_country_of_birth_of_person != 'Not stated'
    AND bplp_country_of_birth_of_person != 'Inadequately described'
    AND born_in_australia IS NOT NULL
  GROUP BY born_in_australia`;

export const CATEGORY_BORN_IN_EN_SPEAKING = `/* CATEGORY_BORN_IN_EN_SPEAKING */
  SELECT main_english_speaking, sum(number) AS number
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_cult_birthpl
    {{optionally_reduce_geo_aggregation_value}}
    AND bplp_country_of_birth_of_person != 'Inadequately described'
    AND born_in_australia = false
    AND bplp_country_of_birth_of_person != 'Not stated'
  GROUP BY main_english_speaking`;

export const CATEGORY_BORN_IN_EN_SPEAKING_NA = `/* CATEGORY_BORN_IN_EN_SPEAKING_NA */ SELECT 0 AS number`;

export const CATEGORY_BORN_IN_EN_SPEAKING_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_BORN_IN_EN_SPEAKING_NA
);

export const CATEGORY_BORN_IN_EN_SPEAKING_STATE_WIDE = `SELECT main_english_speaking, sum(number) AS number \
    FROM ${config.cartodb_username}_{{year}}_ste_cult_birthpl \
    WHERE bplp_country_of_birth_of_person != 'Inadequately described' \
    AND born_in_australia = false \
    AND bplp_country_of_birth_of_person != 'Not stated' \
    GROUP BY main_english_speaking`;

export const CATEGORY_YR_OF_ARRIVAL = `SELECT \
    cartodb_id as id, numerical_year_of_arrival, number \
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_cult_yarp \
  {{optionally_reduce_geo_aggregation_value}} \
  AND numerical_year_of_arrival IS NOT NULL \
  AND numerical_year_of_arrival >= \
   (SELECT MIN(numerical_year_of_arrival) FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_cult_yarp \
   {{optionally_reduce_geo_aggregation_value}} \
   AND number > 0) \
  ORDER BY numerical_year_of_arrival ASC`;

export const CATEGORY_YR_OF_ARRIVAL_NA = `/* CATEGORY_YR_OF_ARRIVAL_NA */ SELECT 0 AS number`;

export const CATEGORY_YR_OF_ARRIVAL_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_YR_OF_ARRIVAL_NA
);

export const CATEGORY_DISABILITY = `/* CATEGORY_DISABILITY */
SELECT
  sexp_sex,
  sum(number) as number,
  broadage10,
  assnp_core_activity_need_for_assistance
FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_disa_age5gendassnp
  {{optionally_reduce_geo_aggregation_value}}
  AND assnp_core_activity_need_for_assistance = 'Has need for assistance with core activities'
GROUP BY
  sexp_sex,
  broadage10,
  assnp_core_activity_need_for_assistance
ORDER BY
  broadage10='85+ years',
  broadage10='65-84 years',
  broadage10='55-64 years',
  broadage10='35-54 years',
  broadage10='25-34 years',
  broadage10='15-24 years',
  broadage10='0-14 years'`;

export const CATEGORY_DISABILITY_NA = naQueryTemplate(
  "CATEGORY_DISABILITY_NA",
  "disa_age5gendassnp",
  "assnp_core_activity_need_for_assistance"
);

export const CATEGORY_DISABILITY_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_DISABILITY_NA
);

export const CATEGORY_UNPAID_CARE = `/* CATEGORY_UNPAID_CARE */
  SELECT sexp_sex,
    sum(number) as number,
    workage10,
    uncarep_unpaid_assistance_to_a_person_with_a_d
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_disa_age5genduncarep
  {{optionally_reduce_geo_aggregation_value}}
  AND uncarep_unpaid_assistance_to_a_person_with_a_d = 'Provided unpaid assistance'
  AND uncarep_unpaid_assistance_to_a_person_with_a_d != 'Not applicable'
  AND workage10 != ''
  GROUP BY sexp_sex,
    workage10,
    uncarep_unpaid_assistance_to_a_person_with_a_d
  ORDER BY workage10='65+ years', workage10='55-64 years', workage10='45-54 years', workage10='35-44 years', workage10='25-34 years', workage10='15-24 years'`;

export const CATEGORY_UNPAID_CARE_NA = naQueryTemplate(
  "CATEGORY_UNPAID_CARE_NA",
  "disa_age5genduncarep",
  "uncarep_unpaid_assistance_to_a_person_with_a_d"
);

export const CATEGORY_UNPAID_CARE_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_UNPAID_CARE_NA
);

export const CATEGORY_INDIGENOUS_STATUS = `SELECT cartodb_id as id, ingp_indigenous_status, number FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_intro_atsi \
    {{optionally_reduce_geo_aggregation_value}} \
    AND ingp_indigenous_status != 'Not stated' \
    AND ingp_indigenous_status != 'Non-Indigenous' \
    ORDER BY
    ingp_indigenous_status = 'Both Aboriginal and Torres Strait Islander',
    ingp_indigenous_status = 'Torres Strait Islander',
    ingp_indigenous_status = 'Aboriginal'`; // column: measure_dimension_variables contains status name

export const CATEGORY_INDIGENOUS_STATUS_NA = naQueryTemplate(
  "CATEGORY_INDIGENOUS_STATUS_NA",
  "intro_atsi",
  "ingp_indigenous_status"
);

export const CATEGORY_INDIGENOUS_STATUS_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_INDIGENOUS_STATUS_NA
);

export const CATEGORY_ENG_OR_NOT = `/* CATEGORY_ENG_OR_NOT */
  SELECT english_spoken_at_home, number
  FROM (
    SELECT
      number as number,
      true as english_spoken_at_home
    FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_cult_englp
      {{optionally_reduce_geo_aggregation_value}}
      AND engp_proficiency_in_spoken_english = 'Speaks English only'
    UNION
    SELECT
      sum(number) as number,
      false as english_spoken_at_home
    FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_cult_englp
      {{optionally_reduce_geo_aggregation_value}}
      AND engp_proficiency_in_spoken_english IN ('Very well', 'Well', 'Not well', 'Not at all')
      GROUP BY english_spoken_at_home
  ) AS subq`;

export const CATEGORY_ENG_OR_NOT_NA = naQueryTemplate(
  "CATEGORY_ENG_OR_NOT_NA",
  "cult_langhome",
  "lanp_language_spoken_at_home"
);

export const CATEGORY_ENG_OR_NOT_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_ENG_OR_NOT_NA
);

export const CATEGORY_ANCESTRY = `SELECT ancp_ancestry_multi_response, number FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_cult_ancp \
   {{optionally_reduce_geo_aggregation_value}} \
   AND ancp_ancestry_multi_response != 'Not applicable' \
   AND ancp_ancestry_multi_response != 'Not stated' \
   AND ancp_ancestry_multi_response != 'Inadequately described' \
   ORDER BY number DESC LIMIT 10`;

export const CATEGORY_ANCESTRY_NA = `SELECT 0 AS number`;
export const CATEGORY_ANCESTRY_COMMUNITY_NA = `SELECT 0 AS number`;

export const CATEGORY_ANCESTRY_TOTAL = `/* CATEGORY_ANCESTRY_TOTAL */
  SELECT SUM(number) AS number
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_cult_ancp
  {{optionally_reduce_geo_aggregation_value}}
  AND ancp_ancestry_multi_response != 'Not applicable'`;

export const CATEGORY_ANCESTRY_TOTAL_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_ANCESTRY_TOTAL
);

export const CATEGORY_ANCESTRY_STATE_TOTAL = `/* CATEGORY_ANCESTRY_STATE_TOTAL */
  SELECT SUM(number) AS number
  FROM ${config.cartodb_username}_{{year}}_ste_cult_ancp
  WHERE ancp_ancestry_multi_response != 'Not applicable'`;

export const CATEGORY_LANG_SPKN = `/* CATEGORY_LANG_SPKN */
  SELECT lanp_language_spoken_at_home, number
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_cult_langhome
    {{optionally_reduce_geo_aggregation_value}}
    AND lanp_language_spoken_at_home != 'Not stated'
    AND lanp_language_spoken_at_home != 'Inadequately described'
    AND lanp_language_spoken_at_home != 'English'
    AND lanp_language_spoken_at_home != 'Non-verbal, so described'
  ORDER BY number DESC LIMIT 10`;

export const CATEGORY_LANG_SPKN_NA = naQueryTemplate(
  "CATEGORY_LANG_SPKN_NA",
  "cult_langhome",
  "lanp_language_spoken_at_home"
);

export const CATEGORY_LANG_SPKN_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_LANG_SPKN_NA
);

export const CATEGORY_PRFCY_ENG = `SELECT engp_proficiency_in_spoken_english, number \
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_cult_englp \
  {{optionally_reduce_geo_aggregation_value}} \
  AND engp_proficiency_in_spoken_english <> 'Not stated' \
  AND engp_proficiency_in_spoken_english <> 'Not applicable' \
  AND engp_proficiency_in_spoken_english IN ('Very well', 'Well', 'Not well', 'Not at all') \
  ORDER BY \
    engp_proficiency_in_spoken_english='Not at all', \
    engp_proficiency_in_spoken_english='Not well', \
    engp_proficiency_in_spoken_english='Well', \
    engp_proficiency_in_spoken_english='Very well'`;


export const CATEGORY_PRFCY_ENG_TOTAL = `/*CATEGORY_PRFCY_ENG_TOTAL*/ 
  select sum(number) as number from ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_cult_englp
  {{optionally_reduce_geo_aggregation_value}} 
  AND engp_proficiency_in_spoken_english NOT IN ('Speaks English only', 'Not stated - both language (LANP) and proficiency (ENGP) not stated', 'Not stated - language (LANP) stated, proficiency (ENGP) not stated')`;

export const CATEGORY_PRFCY_ENG_TOTAL_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_PRFCY_ENG_TOTAL
);

export const CATEGORY_PRFCY_ENG_STATE_TOTAL = `/*CATEGORY_PRFCY_ENG_STATE_TOTAL*/
  SELECT SUM(number) AS number
  FROM ${config.cartodb_username}_{{year}}_ste_cult_englp
  WHERE 1=1
  AND engp_proficiency_in_spoken_english NOT IN ('Speaks English only', 'Not stated - both language (LANP) and proficiency (ENGP) not stated', 'Not stated - language (LANP) stated, proficiency (ENGP) not stated')`;

export const CATEGORY_PRFCY_ENG_NA = naQueryTemplate(
  "CATEGORY_PRFCY_ENG_NA",
  "cult_englp",
  "engp_proficiency_in_spoken_english"
);

export const CATEGORY_PRFCY_ENG_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_PRFCY_ENG_NA
);

export const CATEGORY_RELIGION = `/* CATEGORY_RELIGION */ SELECT relp_1, sum(number) AS number FROM
     ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_cult_relp
     {{optionally_reduce_geo_aggregation_value}}
     AND relp_1 != 'Not stated'
     AND relp_1 != 'Supplementary codes'
     AND relp_1 != 'Inadequately described'
     GROUP BY relp_1
     ORDER BY number DESC LIMIT 10`;

export const CATEGORY_RELIGION_NA = naQueryTemplate(
  "CATEGORY_RELIGION_NA",
  "cult_relp",
  "relp_1"
);

export const CATEGORY_RELIGION_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_RELIGION_NA
);

export const CATEGORY_CITIZENSHIP =
  // TODO: FIXME: should be fixed in the DB see issue #161
  `/* CATEGORY_CITIZENSHIP */ SELECT
    CASE
      WHEN citp_australian_citizenship = 'Not Australian' THEN
        'Not an Australian Citizen'
      WHEN citp_australian_citizenship = 'Australian' THEN
        'Australian Citizen'
      ELSE
        citp_australian_citizenship
    END,
    number
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_cult_citp
  {{optionally_reduce_geo_aggregation_value}}
  AND citp_australian_citizenship != 'Not stated'`;

export const CATEGORY_CITIZENSHIP_NA = naQueryTemplate(
  "CATEGORY_CITIZENSHIP_NA",
  "cult_citp",
  "citp_australian_citizenship"
);

export const CATEGORY_CITIZENSHIP_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_CITIZENSHIP_NA
);

export const CATEGORY_QUALIFICATIONS = `/* CATEGORY_QUALIFICATIONS */ SELECT * FROM (SELECT qallp_main, number, sexp_sex \
   FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_eduwork_qallp \
   {{optionally_reduce_geo_aggregation_value}} \
   AND qallp_main <> 'Not applicable' \
   AND qallp_main <> 'Level of education inadequately described' \
   AND qallp_main <> 'Level of education not stated' \
   ORDER BY number DESC \
   LIMIT 20) as subq ORDER BY \
    qallp_main='Certificate Level', \
    qallp_main='Advanced Diploma and Diploma Level', \
    qallp_main='Bachelor Degree Level', \
    qallp_main='Graduate Diploma and Graduate Certificate Level', \
    qallp_main='Postgraduate Degree Level'`;

export const CATEGORY_QUALIFICATIONS_TOTAL = `/*CATEGORY_QUALIFICATIONS_TOTAL*/ 
  select sum(number) as number from ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_eduwork_qallp
  {{optionally_reduce_geo_aggregation_value}} 
  AND qallp_main != 'Not applicable'`;

export const CATEGORY_QUALIFICATIONS_TOTAL_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_QUALIFICATIONS_TOTAL
);

export const CATEGORY_QUALIFICATIONS_STATE_TOTAL = `/*CATEGORY_QUALIFICATIONS_STATE_TOTAL*/
  SELECT SUM(number) AS number
  FROM ${config.cartodb_username}_{{year}}_ste_eduwork_qallp
  WHERE 1=1
  AND qallp_main != 'Not applicable'`;
  
export const CATEGORY_QUALIFICATIONS_NA = naQueryTemplate(
  "CATEGORY_QUALIFICATIONS_NA",
  "eduwork_qallp",
  "qallp_main"
);

export const CATEGORY_QUALIFICATIONS_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_QUALIFICATIONS_NA
);

export const CATEGORY_EDUCATION = `SELECT tystap_main, number, sexp_sex \
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_eduwork_tystap \
  {{optionally_reduce_geo_aggregation_value}} \
  AND tystap_main <> 'Not Stated' \
  AND tystap_main <> 'Not applicable' \
  ORDER BY
  tystap_main = 'Other',
  tystap_main = 'University/Tertiary',
  tystap_main = 'TAFE',
  tystap_main = 'Secondary',
  tystap_main = 'Infants/Primary',
  tystap_main = 'Pre-school'`;

export const CATEGORY_EDUCATION_TOTAL = `/*_CATEGORY_EDUCATION_TOTAL_*/ 
  SELECT sum(number) as number FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_eduwork_tystap
  {{optionally_reduce_geo_aggregation_value}} 
  AND tystap_main != 'Not applicable'`;


export const CATEGORY_EDUCATION_TOTAL_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_EDUCATION_TOTAL
);

export const CATEGORY_EDUCATION_STATE_TOTAL = `/*_CATEGORY_EDUCATION_STATE_TOTAL_*/
  SELECT SUM(number) AS number
  FROM ${config.cartodb_username}_{{year}}_ste_eduwork_tystap
  WHERE 1=1
  AND tystap_main != 'Not applicable'`;

export const CATEGORY_EDUCATION_NA = naQueryTemplate(
  "CATEGORY_EDUCATION_NA",
  "eduwork_tystap",
  "tystap_main"
);

export const CATEGORY_EDUCATION_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_EDUCATION_NA
);

export const CATEGORY_EMPLOYMENT_STATUS = `SELECT lfhrp_labour_force_status_and_hours_worked_not, sum(number) as number, sexp_sex \
    FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_eduwork_empl \
    {{optionally_reduce_geo_aggregation_value}} \
    AND lfhrp_labour_force_status_and_hours_worked_not  <> 'Not applicable' \
    AND lfhrp_labour_force_status_and_hours_worked_not  <> 'Labour force status not stated' \
    GROUP BY lfhrp_labour_force_status_and_hours_worked_not, sexp_sex \
    ORDER BY \
      lfhrp_labour_force_status_and_hours_worked_not='Labour force status not stated', \
      lfhrp_labour_force_status_and_hours_worked_not='Not in the labour force', \
      lfhrp_labour_force_status_and_hours_worked_not='Unemployed', \
      lfhrp_labour_force_status_and_hours_worked_not='Employed, hours of work not stated or away from work', \
      lfhrp_labour_force_status_and_hours_worked_not='Employed, worked part-time', \
      lfhrp_labour_force_status_and_hours_worked_not='Employed, worked full-time'`;

export const CATEGORY_EMPLOYMENT_STATUS_NA = naQueryTemplate(
  "CATEGORY_EMPLOYMENT_STATUS_NA",
  "eduwork_empl",
  "lfhrp_labour_force_status_and_hours_worked_not"
);

export const CATEGORY_EMPLOYMENT_STATUS_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_EMPLOYMENT_STATUS_NA
);

export const CATEGORY_OCCUPATION_NA = naQueryTemplate(
  "CATEGORY_OCCUPATION_NA",
  "eduwork_occp",
  "occp_main"
);

export const CATEGORY_OCCUPATION_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_OCCUPATION_NA
);

export const CATEGORY_OCCUPATION = `SELECT occp_main, number, sexp_sex FROM ${config.cartodb_username}.${config.cartodb_username}_{{year}}_{{geo_aggregation}}_eduwork_occp \
       {{optionally_reduce_geo_aggregation_value}} \
       AND occp_main IN \
       (SELECT occp_main FROM \
         (SELECT occp_main, sum(number) as number \
           FROM ${config.cartodb_username}.${config.cartodb_username}_{{year}}_{{geo_aggregation}}_eduwork_occp \
           {{optionally_reduce_geo_aggregation_value}} \
           AND occp_main <> 'Inadequately described' \
           AND occp_main <> 'Not stated' \
           AND occp_main <> 'Not applicable' \
           GROUP BY occp_main \
           ORDER BY number DESC \
           LIMIT 10) as dummyalias) \
        GROUP BY occp_main, number, sexp_sex\
        ORDER BY \
          occp_main='Labourers', \
          occp_main='Machinery Operators and Drivers', \
          occp_main='Sales Workers', \
          occp_main='Clerical and Administrative Workers', \
          occp_main='Community and Personal Service Workers', \
          occp_main='Technicians and Trades Workers', \
          occp_main='Professionals', \
          occp_main='Managers'`;

export const CATEGORY_OCCUPATION_TOTAL = `/*CATEGORY_OCCUPATION_TOTAL*/ 
  SELECT sum(number) as number FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_eduwork_occp
  {{optionally_reduce_geo_aggregation_value}} 
  AND occp_main != 'Not applicable'`;

export const CATEGORY_OCCUPATION_TOTAL_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_OCCUPATION_TOTAL
);

export const CATEGORY_OCCUPATION_STATE_TOTAL = `/*CATEGORY_OCCUPATION_STATE_TOTAL*/
  SELECT SUM(number) AS number
  FROM ${config.cartodb_username}_{{year}}_ste_eduwork_occp
  WHERE 1=1
  AND occp_main != 'Not applicable'`;

export const CATEGORY_INCOME = `/* CATEGORY_INCOME */
  SELECT
    incp_total_personal_income_weekly,
    sum(number) as number,
    sexp_sex,
    '{{year}}' AS year
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_eduwork_incp
    {{optionally_reduce_geo_aggregation_value}}
    AND incp_total_personal_income_weekly <> 'Not stated'
    AND incp_total_personal_income_weekly <> 'Not applicable'
  GROUP BY sexp_sex, incp_total_personal_income_weekly, year
  ORDER BY COALESCE((
    SELECT
    (regexp_matches(
      regexp_replace(incp_total_personal_income_weekly, '$|,' , '', 'g'),
      '([0-9]+)'
    ))[1]::integer
  ), 0) DESC`;

export const CATEGORY_INCOME_NA = naQueryTemplate(
  "CATEGORY_INCOME_NA",
  "eduwork_incp",
  "incp_total_personal_income_weekly"
);

export const CATEGORY_INCOME_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_INCOME_NA
);

export const CATEGORY_VOLUNTARY_WORK = `/* CATEGORY_VOLUNTARY_WORK */
  SELECT
    workage10,
    sum(number) as number,
    sexp_sex
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_eduwork_age10volwp
  {{optionally_reduce_geo_aggregation_value}}
  AND volwp_voluntary_work_for_an_organisation_or_group = 'Volunteer'
  AND workage10 != ''
  GROUP BY
    workage10,
    sexp_sex,
    volwp_voluntary_work_for_an_organisation_or_group
  ORDER BY workage10`;

export const CATEGORY_VOLUNTARY_WORK_NA = naQueryTemplate(
  "CATEGORY_VOLUNTARY_WORK_NA",
  "eduwork_age10volwp",
  "volwp_voluntary_work_for_an_organisation_or_group"
);

export const CATEGORY_VOLUNTARY_WORK_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_VOLUNTARY_WORK_NA
);

export const CATEGORY_FAMILY_COMPOSITION = `/* CATEGORY_FAMILY_COMPOSITION */
  SELECT fmcf_main, number
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_house_FMCF
  {{optionally_reduce_geo_aggregation_value}}
  AND fmcf_main <> 'Not applicable'
  ORDER BY
  fmcf_main = 'Other family',
  fmcf_main = 'One parent family',
  fmcf_main = 'Couple family with children',
  fmcf_main = 'Couple family with no children'`;

export const CATEGORY_FAMILY_COMPOSITION_TOTAL = `/*CATEGORY_FAMILY_COMPOSITION_TOTAL*/ 
  SELECT sum(number) as number FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_house_FMCF
  {{optionally_reduce_geo_aggregation_value}} 
  AND fmcf_main != 'Not applicable'`;

export const CATEGORY_FAMILY_COMPOSITION_TOTAL_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_FAMILY_COMPOSITION_TOTAL
);

export const CATEGORY_FAMILY_COMPOSITION_STATE_TOTAL = `/*CATEGORY_FAMILY_COMPOSITION_STATE_TOTAL*/
  SELECT SUM(number) AS number
  FROM ${config.cartodb_username}_{{year}}_ste_house_FMCF
  WHERE 1=1
  AND fmcf_main != 'Not applicable'`;

export const CATEGORY_FAMILY_COMPOSITION_NA = naQueryTemplate(
  "CATEGORY_FAMILY_COMPOSITION_NA",
  "house_FMCF",
  "fmcf_main"
);

export const CATEGORY_FAMILY_COMPOSITION_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_FAMILY_COMPOSITION_NA
);

const children_sort_order = [
  "cdcf_main='No dependent children'",
  "cdcf_main='One dependent child'",
  "cdcf_main='Two dependent children'",
  "cdcf_main='Three dependent children'",
  "cdcf_main='Four dependent children'",
  "cdcf_main='Five or more dependent children'",
];
export const CATEGORY_CHILDREN_IN_FAMILY = `/* CATEGORY_CHILDREN_IN_FAMILY */
  SELECT cdcf_main, number
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_house_CDCF
  {{optionally_reduce_geo_aggregation_value}}
  AND cdcf_main <> 'Not applicable'
  ORDER BY ${children_sort_order.reverse().join(",")}`;

export const CATEGORY_CHILDREN_IN_FAMILY_TOTAL = `/*CATEGORY_CHILDREN_IN_FAMILY_TOTAL*/ 
  SELECT sum(number) as number FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_house_CDCF
  {{optionally_reduce_geo_aggregation_value}} 
  AND cdcf_main != 'Not applicable'`;

export const CATEGORY_CHILDREN_IN_FAMILY_TOTAL_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_CHILDREN_IN_FAMILY_TOTAL
);

export const CATEGORY_CHILDREN_IN_FAMILY_STATE_TOTAL = `/*CATEGORY_CHILDREN_IN_FAMILY_STATE_TOTAL*/
  SELECT SUM(number) AS number
  FROM ${config.cartodb_username}_{{year}}_ste_house_CDCF
  WHERE 1=1
  AND cdcf_main != 'Not applicable'`;

export const CATEGORY_CHILDREN_IN_FAMILY_NA = naQueryTemplate(
  "CATEGORY_CHILDREN_IN_FAMILY_NA",
  "house_CDCF",
  "cdcf_main"
);

export const CATEGORY_CHILDREN_IN_FAMILY_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_CHILDREN_IN_FAMILY_NA
);

export const CATEGORY_PERSONS_IN_PRIVATE_DWELLING_TOTAL = `/*CATEGORY_PERSONS_IN_PRIVATE_DWELLING_TOTAL*/ 
  SELECT sum(number) as number FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_house_nprd
  {{optionally_reduce_geo_aggregation_value}} 
  AND nprd_number_of_persons_usually_resident_in_dwe != 'Not applicable'`;

export const CATEGORY_PERSONS_IN_PRIVATE_DWELLING_TOTAL_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_PERSONS_IN_PRIVATE_DWELLING_TOTAL
);

export const CATEGORY_PERSONS_IN_PRIVATE_DWELLING_STATE_TOTAL = `/*CATEGORY_PERSONS_IN_PRIVATE_DWELLING_STATE_TOTAL*/
  SELECT SUM(number) AS number
  FROM ${config.cartodb_username}_{{year}}_ste_house_nprd
  WHERE 1=1
  AND nprd_number_of_persons_usually_resident_in_dwe != 'Not applicable'`;

export const CATEGORY_RESIDENTS_IN_DWELLING = `/* CATEGORY_RESIDENTS_IN_DWELLING */
  SELECT nprd_number_of_persons_usually_resident_in_dwe, sum(number) as number
    FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_house_nprd
    {{optionally_reduce_geo_aggregation_value}}
    AND nprd_number_of_persons_usually_resident_in_dwe <> 'Not applicable'
    GROUP BY nprd_number_of_persons_usually_resident_in_dwe 
    ORDER BY
      nprd_number_of_persons_usually_resident_in_dwe='Six or more persons',
      nprd_number_of_persons_usually_resident_in_dwe='Five persons',
      nprd_number_of_persons_usually_resident_in_dwe='Four persons',
      nprd_number_of_persons_usually_resident_in_dwe='Three persons',
      nprd_number_of_persons_usually_resident_in_dwe='Two persons',
      nprd_number_of_persons_usually_resident_in_dwe='One person'`;

export const CATEGORY_RESIDENTS_IN_DWELLING_NA = naQueryTemplate(
  "CATEGORY_RESIDENTS_IN_DWELLING_NA",
  "house_nprd",
  "nprd_number_of_persons_usually_resident_in_dwe"
);

export const CATEGORY_RESIDENTS_IN_DWELLING_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_RESIDENTS_IN_DWELLING_NA
);

export const CATEGORY_HOUSEHOLD_INCOME = `/*CATEGORY_HOUSEHOLD_INCOME*/
  SELECT
    hind_total_household_income_weekly,
    sum(number) as number,
    COALESCE((
      SELECT (
        regexp_matches(
          regexp_replace(hind_total_household_income_weekly, '$|,' , '', 'g'),
          '([0-9]+)'
        )
      )[1]::integer
    ), 0) AS lower_range
  FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_house_hind
  {{optionally_reduce_geo_aggregation_value}}
  AND hind_total_household_income_weekly <> 'Not applicable'
  AND hind_total_household_income_weekly <> 'Partial income stated'
  AND hind_total_household_income_weekly <> 'All incomes not stated'
  GROUP BY hind_total_household_income_weekly, lower_range
  ORDER BY lower_range DESC`;

export const CATEGORY_HOUSEHOLD_INCOME_NA = naQueryTemplate(
  "CATEGORY_HOUSEHOLD_INCOME_NA",
  "house_hind",
  "hind_total_household_income_weekly"
);

export const CATEGORY_HOUSEHOLD_INCOME_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_HOUSEHOLD_INCOME_NA
);

export const CATEGORY_INTERNET_ACCESS = `SELECT nedd_type_of_internet_connection, number \
   FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_house_nedd \
   {{optionally_reduce_geo_aggregation_value}} \
   AND nedd_type_of_internet_connection <> 'Not stated' \
   AND nedd_type_of_internet_connection <> 'Not applicable' \
   ORDER BY 
   nedd_type_of_internet_connection = 'Other connection',
   nedd_type_of_internet_connection = 'Dial-up connection',
   nedd_type_of_internet_connection = 'Broadband connection',
   nedd_type_of_internet_connection = 'No Internet connection'`;
export const CATEGORY_INTERNET_ACCESS_NA = naQueryTemplate(
  "CATEGORY_INTERNET_ACCESS_NA",
  "house_nedd",
  "nedd_type_of_internet_connection"
);

export const CATEGORY_INTERNET_ACCESS_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_INTERNET_ACCESS_NA
);

export const CATEGORY_SEIFA = `SELECT irsd_deciles_at_lga_level_pop, number \
   FROM ${config.cartodb_username}_{{year}}_{{geo_aggregation}}_house_irsdlgapop \
   {{optionally_reduce_geo_aggregation_value}} \
   AND irsd_deciles_at_lga_level_pop <> 'Not stated' \
   AND irsd_deciles_at_lga_level_pop <> 'Not applicable' \
   ORDER BY irsd_deciles_at_lga_level_pop`;

export const CATEGORY_SEIFA_NA = naQueryTemplate(
  "CATEGORY_SEIFA_NA",
  "house_irsdlgapop",
  "irsd_deciles_at_lga_level_pop"
);

export const CATEGORY_SEIFA_COMMUNITY_NA = substituteForCommunityAggregation(
  CATEGORY_SEIFA_NA
);

/* lets recreate these queries but make them use the community_value
 * instead of the geo_aggregation to narrow down the results*/
export const CATEGORY_AGE_AND_GENDER_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_AGE_AND_GENDER
);
export const CATEGORY_SERVICE_AGE_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_SERVICE_AGE 
);
export const CATEGORY_BIRTHPLACE_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_BIRTHPLACE
);
export const CATEGORY_LGA_DISTRIBUTION_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_LGA_DISTRIBUTION
);
export const CATEGORY_BORN_IN_AU_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_BORN_IN_AU
);
export const CATEGORY_BORN_IN_EN_SPEAKING_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_BORN_IN_EN_SPEAKING
);
export const CATEGORY_YR_OF_ARRIVAL_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_YR_OF_ARRIVAL
);
export const CATEGORY_DISABILITY_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_DISABILITY
);
export const CATEGORY_UNPAID_CARE_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_UNPAID_CARE
);
export const CATEGORY_INDIGENOUS_STATUS_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_INDIGENOUS_STATUS
);
export const CATEGORY_ENG_OR_NOT_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_ENG_OR_NOT
);
export const CATEGORY_ANCESTRY_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_ANCESTRY
);
export const CATEGORY_LANG_SPKN_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_LANG_SPKN
);
export const CATEGORY_PRFCY_ENG_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_PRFCY_ENG
);
export const CATEGORY_RELIGION_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_RELIGION
);
export const CATEGORY_CITIZENSHIP_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_CITIZENSHIP
);
export const CATEGORY_QUALIFICATIONS_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_QUALIFICATIONS
);
export const CATEGORY_EDUCATION_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_EDUCATION
);
export const CATEGORY_EMPLOYMENT_STATUS_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_EMPLOYMENT_STATUS
);
export const CATEGORY_OCCUPATION_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_OCCUPATION
);
export const CATEGORY_INCOME_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_INCOME
);
export const CATEGORY_VOLUNTARY_WORK_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_VOLUNTARY_WORK
);
export const CATEGORY_FAMILY_COMPOSITION_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_FAMILY_COMPOSITION
);
export const CATEGORY_CHILDREN_IN_FAMILY_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_CHILDREN_IN_FAMILY
);
export const CATEGORY_RESIDENTS_IN_DWELLING_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_RESIDENTS_IN_DWELLING
);
export const CATEGORY_HOUSEHOLD_INCOME_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_HOUSEHOLD_INCOME
);
export const CATEGORY_INTERNET_ACCESS_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_INTERNET_ACCESS
);
export const CATEGORY_SEIFA_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_SEIFA
);
export const TOTAL_POPULATION_COMMUNITY = substituteForCommunityAggregation(
  TOTAL_POPULATION
);

export const CATEGORY_AGE_AND_GENDER_TOTAL_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_AGE_AND_GENDER_TOTAL
);

export const CATEGORY_BIRTHPLACE_TOP_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_BIRTHPLACE_TOP
);

export const BIRTHPLACE_NOT_STATED_COMMUNITY = substituteForCommunityAggregation(
  BIRTHPLACE_NOT_STATED
);

const removeGeoAggregationNarrowing = (query) =>
  query
    .replace(
      /\{\{optionally_reduce_geo_aggregation_value\}\}\s*(AND)?/g,
      (_, and) => (and ? "WHERE" : "")
    )
    .replace(/\{\{geo_aggregation\}\}/g, "ste")
    .replace(/LIMIT \d+/, "");

/* now lets recreate these queries to have them explicitly query on the state level*/
export const CATEGORY_AGE_AND_GENDER_STATE = removeGeoAggregationNarrowing(
  CATEGORY_AGE_AND_GENDER
);
export const CATEGORY_SERVICE_AGE_STATE = removeGeoAggregationNarrowing(
  CATEGORY_SERVICE_AGE 
);
export const CATEGORY_BIRTHPLACE_STATE = removeGeoAggregationNarrowing(
  CATEGORY_BIRTHPLACE
);
export const CATEGORY_LGA_DISTRIBUTION_STATE = removeGeoAggregationNarrowing(
  CATEGORY_LGA_DISTRIBUTION
);
export const CATEGORY_BORN_IN_AU_STATE = removeGeoAggregationNarrowing(
  CATEGORY_BORN_IN_AU
);
export const CATEGORY_BORN_IN_EN_SPEAKING_STATE = removeGeoAggregationNarrowing(
  CATEGORY_BORN_IN_EN_SPEAKING
);
export const CATEGORY_YR_OF_ARRIVAL_STATE = removeGeoAggregationNarrowing(
  CATEGORY_YR_OF_ARRIVAL
);
export const CATEGORY_DISABILITY_STATE = removeGeoAggregationNarrowing(
  CATEGORY_DISABILITY
);
export const CATEGORY_UNPAID_CARE_STATE = removeGeoAggregationNarrowing(
  CATEGORY_UNPAID_CARE
);
export const CATEGORY_INDIGENOUS_STATUS_STATE = removeGeoAggregationNarrowing(
  CATEGORY_INDIGENOUS_STATUS
);
export const CATEGORY_ENG_OR_NOT_STATE = removeGeoAggregationNarrowing(
  CATEGORY_ENG_OR_NOT
);
export const CATEGORY_ANCESTRY_STATE = removeGeoAggregationNarrowing(
  CATEGORY_ANCESTRY
);
export const CATEGORY_LANG_SPKN_STATE = removeGeoAggregationNarrowing(
  CATEGORY_LANG_SPKN
);
export const CATEGORY_PRFCY_ENG_STATE = removeGeoAggregationNarrowing(
  CATEGORY_PRFCY_ENG
);
export const CATEGORY_RELIGION_STATE = removeGeoAggregationNarrowing(
  CATEGORY_RELIGION
);
export const CATEGORY_CITIZENSHIP_STATE = removeGeoAggregationNarrowing(
  CATEGORY_CITIZENSHIP
);
export const CATEGORY_QUALIFICATIONS_STATE = removeGeoAggregationNarrowing(
  CATEGORY_QUALIFICATIONS
);
export const CATEGORY_EDUCATION_STATE = removeGeoAggregationNarrowing(
  CATEGORY_EDUCATION
);
export const CATEGORY_EMPLOYMENT_STATUS_STATE = removeGeoAggregationNarrowing(
  CATEGORY_EMPLOYMENT_STATUS
);
export const CATEGORY_OCCUPATION_STATE = removeGeoAggregationNarrowing(
  CATEGORY_OCCUPATION
);
export const CATEGORY_INCOME_STATE = removeGeoAggregationNarrowing(
  CATEGORY_INCOME
);
export const CATEGORY_VOLUNTARY_WORK_STATE = removeGeoAggregationNarrowing(
  CATEGORY_VOLUNTARY_WORK
);
export const CATEGORY_FAMILY_COMPOSITION_STATE = removeGeoAggregationNarrowing(
  CATEGORY_FAMILY_COMPOSITION
);
export const CATEGORY_CHILDREN_IN_FAMILY_STATE = removeGeoAggregationNarrowing(
  CATEGORY_CHILDREN_IN_FAMILY
);
export const CATEGORY_RESIDENTS_IN_DWELLING_STATE = removeGeoAggregationNarrowing(
  CATEGORY_RESIDENTS_IN_DWELLING
);
export const CATEGORY_HOUSEHOLD_INCOME_STATE = removeGeoAggregationNarrowing(
  CATEGORY_HOUSEHOLD_INCOME
);
export const CATEGORY_INTERNET_ACCESS_STATE = removeGeoAggregationNarrowing(
  CATEGORY_INTERNET_ACCESS
);
export const CATEGORY_SEIFA_STATE = removeGeoAggregationNarrowing(
  CATEGORY_SEIFA
);

// Comparison Queries:

// run this when {state: {geo_aggregation, geo_aggregation_value}}
// ["lga", "sed"].includes(geo_aggregation) and showFor === "geo_aggregation"
// TODO: template for: year, geo_aggregation, geo_aggregation_value
export const CATEGORY_INDIGENOUS_STATUS_COMPARISON = `
/* Community percentages, replace with geo_aggregation and year */
(with total AS (SELECT sum(number) AS total
                FROM dlgc_{{year}}_{{geo_aggregation}}_intro_atsi
                {{optionally_reduce_geo_aggregation_value}})
 SELECT {{geo_aggregation_value_column}} AS community, ingp_indigenous_status, number, ROUND((number/total.total * 100)::numeric, 1) AS percentage
 FROM dlgc_{{year}}_{{geo_aggregation}}_intro_atsi, total
 {{optionally_reduce_geo_aggregation_value}})

 UNION

 /* State percentages */
(with total AS (SELECT sum(number) AS total
                FROM dlgc_{{year}}_ste_intro_atsi)
 SELECT main_statistical_area_structure_main_asgs_ur AS community, ingp_indigenous_status, number, ROUND((number/total.total * 100)::numeric, 1) AS percentage
 FROM dlgc_{{year}}_ste_intro_atsi, total)
ORDER BY ingp_indigenous_status, community`;

// 20200818 CATEGORY_SERVICE_AGE_COMPARISON and CATEGORY_AGE_COMPARISON are currently swapped
export const CATEGORY_SERVICE_AGE_COMPARISON = `/* Community percentages, replace with geo_aggregation */
(with total AS (SELECT sum(number) AS total
                FROM dlgc_{{year}}_{{geo_aggregation}}_demo_age5gend
                {{optionally_reduce_geo_aggregation_value}})
 SELECT {{geo_aggregation_value_column}} AS community, age5p_age_in_five_year_groups, sum(number) as number, ROUND((sum(number) / total.total * 100)::numeric, 1) AS percentage, total.total
 FROM dlgc_{{year}}_{{geo_aggregation}}_demo_age5gend, total
 {{optionally_reduce_geo_aggregation_value}}
 GROUP BY {{geo_aggregation_value_column}}, age5p_age_in_five_year_groups, total)
 
 UNION
 
 /* State percentages */
(with total AS (SELECT sum(number) AS total
                FROM dlgc_{{year}}_ste_demo_age5gend)
 SELECT main_statistical_area_structure_main_asgs_ur AS community, age5p_age_in_five_year_groups, sum(number) as number, ROUND((sum(number) / total.total * 100)::numeric, 1) AS percentage, total.total
 FROM dlgc_{{year}}_ste_demo_age5gend, total
 GROUP BY main_statistical_area_structure_main_asgs_ur, age5p_age_in_five_year_groups, total)
 ORDER BY age5p_age_in_five_year_groups, community`;

export const CATEGORY_AGE_COMPARISON = `/* Community percentages, replace with geo_aggregation */
(with total AS (SELECT sum(number) AS total
                FROM dlgc_{{year}}_{{geo_aggregation}}_demo_age5gend
                {{optionally_reduce_geo_aggregation_value}})
 SELECT {{geo_aggregation_value_column}} AS community, service_age, sum(number) as number, ROUND((sum(number) / total.total * 100)::numeric, 1) AS percentage, total.total
 FROM dlgc_{{year}}_{{geo_aggregation}}_demo_age5gend, total
 {{optionally_reduce_geo_aggregation_value}}
 GROUP BY {{geo_aggregation_value_column}}, service_age, total)
 
 UNION
 
 /* State percentages */
(with total AS (SELECT sum(number) AS total
                FROM dlgc_{{year}}_ste_demo_age5gend)
 SELECT main_statistical_area_structure_main_asgs_ur AS community, service_age, sum(number) as number, ROUND((sum(number) / total.total * 100)::numeric, 1) AS percentage, total.total
 FROM dlgc_{{year}}_ste_demo_age5gend, total
 GROUP BY main_statistical_area_structure_main_asgs_ur, service_age, total)
 ORDER BY service_age, community`;

export const CATEGORY_BORN_IN_MES_NNMES_COMPARISON = `/* Community percentages, replace with geo_aggregation */
 (WITH total AS (SELECT sum(number) AS total
                 FROM dlgc_{{year}}_{{geo_aggregation}}_cult_birthpl
                 {{optionally_reduce_geo_aggregation_value}})
 SELECT {{geo_aggregation_value_column}} as community, main_english_speaking, sum(number) as number, ROUND((sum(number) / total.total * 100)::numeric, 1) as percentage
 FROM dlgc_{{year}}_{{geo_aggregation}}_cult_birthpl, total
 {{optionally_reduce_geo_aggregation_value}}
 AND bplp_country_of_birth_of_person != 'Inadequately described'
 AND born_in_australia = false
 AND bplp_country_of_birth_of_person != 'Not stated'
 GROUP BY main_english_speaking, total.total, community)
   
 UNION
   
 /* State percentages */
 
 (WITH total AS (SELECT sum(number) AS total
                 FROM dlgc_{{year}}_ste_cult_birthpl) 
 SELECT main_statistical_area_structure_main_asgs_ur  as community, main_english_speaking, sum(number) as number, ROUND((sum(number) / total.total * 100)::numeric, 1) as percentage
 FROM dlgc_{{year}}_ste_cult_birthpl, total
 WHERE bplp_country_of_birth_of_person != 'Inadequately described'
 AND born_in_australia = false
 AND bplp_country_of_birth_of_person != 'Not stated'
 GROUP BY main_english_speaking, total.total, community)`;

export const CATEGORY_BORN_OVERSEAS_COMPARISON = `/* Community percentages, replace with geo_aggregation */
 (WITH total AS (SELECT sum(number) AS total
                 FROM dlgc_{{year}}_{{geo_aggregation}}_cult_birthpl
                 {{optionally_reduce_geo_aggregation_value}})
   SELECT born_in_australia, {{geo_aggregation_value_column}} as community, sum(number) as number, ROUND((sum(number) / total.total * 100)::numeric, 1) as percentage
   FROM dlgc_{{year}}_{{geo_aggregation}}_cult_birthpl, total
   {{optionally_reduce_geo_aggregation_value}}
     AND bplp_country_of_birth_of_person != 'Not stated'
     AND bplp_country_of_birth_of_person != 'Inadequately described'
     AND born_in_australia IS NOT NULL
   GROUP BY born_in_australia, community, total.total)
   
   UNION
   
  /* State percentages */
   (WITH total AS (SELECT sum(number) AS total
                 FROM dlgc_{{year}}_ste_cult_birthpl)
   SELECT born_in_australia, main_statistical_area_structure_main_asgs_ur as community, sum(number) as number, ROUND((sum(number) / total.total * 100)::numeric, 1) as percentage
   FROM dlgc_{{year}}_ste_cult_birthpl, total
     WHERE bplp_country_of_birth_of_person != 'Not stated'
     AND bplp_country_of_birth_of_person != 'Inadequately described'
     AND born_in_australia IS NOT NULL
   GROUP BY born_in_australia, community, total.total)`;

export const CATEGORY_ANCESTRY_COMPARISON = `/* Community percentages, replace with geo_aggregation */
   (with total AS (SELECT sum(number) AS total
                   FROM dlgc_{{year}}_{{geo_aggregation}}_cult_ancp
                   {{optionally_reduce_geo_aggregation_value}}
                   AND ancp_ancestry_multi_response != 'Not applicable')
   SELECT {{geo_aggregation_value_column}} as community, ancp_ancestry_multi_response, number, ROUND((number/total.total * 100)::numeric, 1) as percentage FROM dlgc_{{year}}_{{geo_aggregation}}_cult_ancp, total
   {{optionally_reduce_geo_aggregation_value}}
   AND ancp_ancestry_multi_response != 'Not applicable'
   AND ancp_ancestry_multi_response != 'Not stated'
   ORDER BY number DESC LIMIT 10)
   
   UNION
   
   
   /* State percentages NB: geo_aggregation is also used below in "WHERE ancp" subquery*/
   (with total AS (SELECT sum(number) AS total
                   FROM dlgc_{{year}}_ste_cult_ancp
                   WHERE ancp_ancestry_multi_response != 'Not applicable')
   SELECT main_statistical_area_structure_main_asgs_ur as community, ancp_ancestry_multi_response, number, ROUND((number/total.total * 100)::numeric, 1) as percentage FROM dlgc_{{year}}_ste_cult_ancp, total
   WHERE ancp_ancestry_multi_response IN (SELECT ancp_ancestry_multi_response
                                        FROM dlgc_{{year}}_{{geo_aggregation}}_cult_ancp
                                        {{optionally_reduce_geo_aggregation_value}}
                                        AND ancp_ancestry_multi_response != 'Not applicable'
                                        AND ancp_ancestry_multi_response != 'Not stated'
                                        ORDER BY number DESC LIMIT 10))
   
   ORDER BY community, percentage DESC`;

export const CATEGORY_LANG_SPKN_AT_HOME_COMPARISON = `/* Community percentages, replace with geo_aggregation */
   (with total AS (SELECT sum(number) AS total
                   FROM dlgc_{{year}}_{{geo_aggregation}}_cult_langhome
                   {{optionally_reduce_geo_aggregation_value}})
   SELECT {{geo_aggregation_value_column}} as community, lanp_language_spoken_at_home, number, ROUND((number/total.total * 100)::numeric, 1) as percentage FROM dlgc_{{year}}_{{geo_aggregation}}_cult_langhome, total
   {{optionally_reduce_geo_aggregation_value}}
   AND lanp_language_spoken_at_home != 'Not applicable'
   AND lanp_language_spoken_at_home != 'Not stated'
   AND lanp_language_spoken_at_home != 'English'
   ORDER BY number DESC LIMIT 10)
   
   UNION
   
   
   /* State percentages NB: geo_aggregation is also used below in "WHERE lanp" subquery*/
   (with total AS (SELECT sum(number) AS total
                   FROM dlgc_{{year}}_ste_cult_langhome)
   SELECT main_statistical_area_structure_main_asgs_ur as community, lanp_language_spoken_at_home, number, ROUND((number/total.total * 100)::numeric, 1) as percentage FROM dlgc_{{year}}_ste_cult_langhome, total
   WHERE lanp_language_spoken_at_home IN (SELECT lanp_language_spoken_at_home
                                        FROM dlgc_{{year}}_{{geo_aggregation}}_cult_langhome
                                        {{optionally_reduce_geo_aggregation_value}}
                                        AND lanp_language_spoken_at_home != 'Not applicable'
                                        AND lanp_language_spoken_at_home != 'Not stated'
                                        AND lanp_language_spoken_at_home != 'English'
                                        ORDER BY number DESC LIMIT 10))
   
   ORDER BY community, percentage DESC`;

export const CATEGORY_PROFICIENCY_IN_ENGLISH_COMPARISON = `SELECT * FROM (
  
    /* Community percentages, replace with geo_aggregation */
    (WITH total as (SELECT sum(number) as total
                   FROM dlgc_{{year}}_{{geo_aggregation}}_cult_englp
                   {{optionally_reduce_geo_aggregation_value}}
                   AND engp_proficiency_in_spoken_english IN ('Very well', 'Well', 'Not well', 'Not at all'))
    SELECT {{geo_aggregation_value_column}} as community, engp_proficiency_in_spoken_english, number, ROUND((number/total.total * 100)::numeric, 1) as percentage
    FROM dlgc_{{year}}_{{geo_aggregation}}_cult_englp, total
    {{optionally_reduce_geo_aggregation_value}}
    AND engp_proficiency_in_spoken_english IN ('Very well', 'Well', 'Not well', 'Not at all'))
    
    UNION
      
    /* State percentages */
    (WITH total as (SELECT sum(number) as total
                   FROM dlgc_{{year}}_ste_cult_englp
                  WHERE engp_proficiency_in_spoken_english IN ('Very well', 'Well', 'Not well', 'Not at all'))
    SELECT main_statistical_area_structure_main_asgs_ur as community, engp_proficiency_in_spoken_english, number, ROUND((number/total.total * 100)::numeric, 1) as percentage
    FROM dlgc_{{year}}_ste_cult_englp, total
    WHERE engp_proficiency_in_spoken_english IN ('Very well', 'Well', 'Not well', 'Not at all'))
    
    ) as subq
    
    ORDER BY
    community,
    engp_proficiency_in_spoken_english='Not at all',
    engp_proficiency_in_spoken_english='Not well',
    engp_proficiency_in_spoken_english='Well',
    engp_proficiency_in_spoken_english='Very well'`;

export const CATEGORY_RELIGIOUS_AFFILIATION_COMPARISON = `/* Community percentages, replace with geo_aggregation */
    (WITH total as (SELECT sum(number) as total
                   FROM dlgc_{{year}}_{{geo_aggregation}}_cult_relp
                   {{optionally_reduce_geo_aggregation_value}})
    SELECT {{geo_aggregation_value_column}} as community, relp_1, sum(number) as number, ROUND((sum(number) / total.total * 100)::numeric, 1) as percentage
    FROM dlgc_{{year}}_{{geo_aggregation}}_cult_relp, total
    {{optionally_reduce_geo_aggregation_value}}
    AND relp_1 != 'Not stated'
    AND relp_1 != 'Inadequately described'
    AND relp_1 != 'Supplementary codes'
    GROUP BY relp_1, community, total.total)
    
    UNION
    
    /* State percentages */
    (WITH total as (SELECT sum(number) as total
                   FROM dlgc_{{year}}_ste_cult_relp)
    SELECT main_statistical_area_structure_main_asgs_ur as community, relp_1, sum(number) as number, ROUND((sum(number) / total.total * 100)::numeric, 1) as percentage
    FROM dlgc_{{year}}_ste_cult_relp, total
    WHERE relp_1 != 'Not stated'
    AND relp_1 != 'Inadequately described'
    AND relp_1 != 'Supplementary codes'
    GROUP BY relp_1, community, total.total)
    
    ORDER BY community, percentage DESC`;

export const CATEGORY_CITIZENSHIP_COMPARISON = `/* Community percentages, replace with geo_aggregation */
    (WITH total as (SELECT sum(number) as total
                   FROM dlgc_{{year}}_{{geo_aggregation}}_cult_citp
                   {{optionally_reduce_geo_aggregation_value}})
    SELECT
    {{geo_aggregation_value_column}} as community, 
    CASE
    WHEN citp_australian_citizenship = 'Not Australian' THEN 'Not an Australian Citizen'
    WHEN citp_australian_citizenship = 'Australian' THEN 'Australian Citizen'
    ELSE citp_australian_citizenship
    END,
    number,
    ROUND((number/total.total * 100)::numeric, 1) as percentage
    FROM dlgc_{{year}}_{{geo_aggregation}}_cult_citp, total
    {{optionally_reduce_geo_aggregation_value}}
    AND citp_australian_citizenship != 'Not stated')
    
    UNION
    
    /* State percentages */
    (WITH total as (SELECT sum(number) as total
                   FROM dlgc_{{year}}_ste_cult_citp)
    SELECT
    main_statistical_area_structure_main_asgs_ur as community,
    CASE
    WHEN citp_australian_citizenship = 'Not Australian' THEN 'Not an Australian Citizen'
    WHEN citp_australian_citizenship = 'Australian' THEN 'Australian Citizen'
    ELSE citp_australian_citizenship
    END,
    number,
    ROUND((number/total.total * 100)::numeric, 1) as percentage
    FROM dlgc_{{year}}_ste_cult_citp, total
    WHERE citp_australian_citizenship != 'Not stated')`;

export const CATEGORY_AGE_COMPARISON_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_AGE_COMPARISON
);
export const CATEGORY_SERVICE_AGE_COMPARISON_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_SERVICE_AGE_COMPARISON
);
export const CATEGORY_BORN_IN_MES_NNMES_COMPARISON_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_BORN_IN_MES_NNMES_COMPARISON
);
export const CATEGORY_BORN_OVERSEAS_COMPARISON_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_BORN_OVERSEAS_COMPARISON
);
export const CATEGORY_ANCESTRY_COMPARISON_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_ANCESTRY_COMPARISON
);
export const CATEGORY_LANG_SPKN_AT_HOME_COMPARISON_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_LANG_SPKN_AT_HOME_COMPARISON
);
export const CATEGORY_PROFICIENCY_IN_ENGLISH_COMPARISON_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_PROFICIENCY_IN_ENGLISH_COMPARISON
);
export const CATEGORY_RELIGIOUS_AFFILIATION_COMPARISON_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_RELIGIOUS_AFFILIATION_COMPARISON
);
export const CATEGORY_CITIZENSHIP_COMPARISON_COMMUNITY = substituteForCommunityAggregation(
  CATEGORY_CITIZENSHIP_COMPARISON
);



// WEBPACK FOOTER //
// ./services/sqlQueries.js